class Declickables {
	constructor() {
		this.declickables = new Map();
		this.downOnDeclickable = false;
	}

	add(declickable, destroyOnRemove = true) {
		this.declickables.set(declickable[0], {
			element: declickable,
			destroyOnRemove: destroyOnRemove
		});
		this.downOnDeclickable = true;
	}

	remove(declickable) {
		return this.declickables.delete(declickable[0]);
	}

	closeDeclickables(specificClass) {
		for(let [i, declick] of this.declickables) {
			declick = declick.element;
			if(specificClass && !declick.is(specificClass)) {
				continue;
			}
			if(!declick.data('canBeUnclicked')) {
				return;
			}
			declick.trigger('notClicked');
		}
	}

	checkDeclickables(event) {
		var declicked = false;
		for(let [key, declick] of this.declickables) {
			let destroyOnRemove = declick.destroyOnRemove;
			declick = declick.element;
			if(!declick.data('canBeUnclicked')) {
				continue;
			}
			if(!event || (event.target !== declick[0] && !declick.has($(event.target)).length)) {
				declicked = true;
				declick.trigger('notClicked', [event]);
				if(destroyOnRemove === true) {
					this.remove(declick);
				}
				if(typeof destroyOnRemove === "function") {
					destroyOnRemove();
					this.remove(declick);
				}
			}
			else {
			}
		}
		return declicked;
	}

	checkMousedown(event) {
		let target = $(event.target);
		for(let [i, declickable] of this.declickables) {
			if(declickable.element.is(target) || declickable.element.has(target).length) {
				return this.downOnDeclickable = true;
			}
			else {
			}
		}
		return this.downOnDeclickable = false;
	}

	checkMouseup(event) {
		if(!this.downOnDeclickable) {
			this.checkDeclickables(event);
		}
		this.downOnDeclickable = false;
	}

}

let declickables = new Declickables();

$(document).on('click', function(event) {
	declickables.checkMouseup(event);
}).on('mousedown touchstart', function(event) {
	declickables.checkMousedown(event);
});

export { Declickables, declickables };